module.exports = __webpack_public_path__ + "141d4a85/img/lock-icon.bb9c7166.svg";